/*
  Вкладка «Связь»: два подключения организации - линия для звонков и рассылка
  сообщений (§7.8.1).

  Отдельным компонентом с 28.09.2026: вкладка стала вторым подключением и
  перевалила предел размера страницы настроек. Делится по ответственности, а не
  по числу строк - здесь всё про связь и ничего больше.

  Подключения раздельные, потому что это два разных договора с двумя разными
  операторами, и заполняют их в разное время - незаполненная половина не должна
  выглядеть поломкой целого.

  02.10.2026, решение владельца: подключения разложены по вложенным вкладкам
  «Звонок» и «СМС». Две формы подряд читались одной длинной простынёй, и форму
  рассылки приходилось искать прокруткой под формой линии. Вид вложенного ряда
  тот же, что во вкладке «Судебные участки», - переключатель на подложке, чтобы
  второй ряд не читался продолжением первого. Заголовки карточек при этом сняты:
  они повторяли бы название выбранной вкладки.
*/

import { useState } from 'react'

import SettingsSmsChannel from './SettingsSmsChannel.jsx'
import SettingsVoiceChannel from './SettingsVoiceChannel.jsx'
import Tabs, { TabPanel } from './Tabs.jsx'

const CALL = 'call'
const SMS = 'sms'

const CHANNEL_TABS = [
  { key: CALL, title: 'Звонок' },
  { key: SMS, title: 'СМС' },
]

export default function SettingsChannels({ voice, sms, error, onSaveVoice, onSaveSms, onSwitch }) {
  const [tab, setTab] = useState(CALL)

  return (
    <>
      {/*
        Переход между вкладками гасит сообщения страницы - то же правило, что у
        верхнего ряда: «Рассылка - сохранено» над формой линии читалось бы как
        отчёт о том, что человек делает сейчас.
      */}
      <Tabs
        tabs={CHANNEL_TABS}
        active={tab}
        onChange={(key) => {
          setTab(key)
          onSwitch?.()
        }}
        nested
      />

      <TabPanel tabKey={CALL} active={tab}>
        <section className="card">
          {/*
            Отказ нужен форме целиком: причину она ставит под тем полем, которое
            сервер не принял (25.09.2026).
          */}
          <SettingsVoiceChannel channel={voice} error={error} onSave={onSaveVoice} />
        </section>
      </TabPanel>

      <TabPanel tabKey={SMS} active={tab}>
        <section className="card">
          <SettingsSmsChannel channel={sms} error={error} onSave={onSaveSms} />
        </section>
      </TabPanel>
    </>
  )
}
